define("calendar/components/calendar/settings/bttp", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@glimmer/component", "ember-concurrency", "moment", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _component2, _emberConcurrency, _moment, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.getBttpInclusionDates = getBttpInclusionDates;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"ember-concurrency",0,"moment",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <hr class="u--m__b__0" {{did-insert this.handleBttpError}} />
  <div class="u--row at--bttpChecklist__SettingsBttp">
    <div class="u--col__4 u--m__t__md">
      <h5 class="u--text--md u--m__t__0" data-test-id="calendar-settings-bttp-title">
        {{#if this.isTiktok}}
          {{t "bttp.tiktok.title"}}
        {{else}}
          {{t "bttp.title"}}
        {{/if}}
      </h5>
    </div>
  
    <div class="u--col__8 u--m__t__md at--bttpRetention__bttpSection">
      {{#if (not this.canBttp)}}
        {{#if this.isLegacyAccount}}
          <Calendar::Settings::Bttp::LegacyAccount />
        {{else}}
          <Calendar::Settings::Bttp::Enable
            @isOnLegacyPlan={{this.isOnLegacyPlan}}
            @upgradeButtonText={{this.upgradeButtonText}}
          />
        {{/if}}
      {{else if (and (not this.rolloutBttpV3) this.notEnoughTikTokFollowers)}}
        <Calendar::Settings::Bttp::Followers
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
          @nickname={{this.socialProfile.displayNickname}}
          @numberOfFollowers={{this.numberOfFollowers}}
          @profileType={{this.socialProfile.capitalizedProfileType}}
          @requiredFollowers={{this.requiredFollowers}}
        />
      {{else if (and this.isLegacyBttp this.immediateBttpEnabled)}}
        <Calendar::Settings::Bttp::Upgrade
          @isInstagram={{this.isInstagram}}
          @rolloutBttpV3={{this.rolloutBttpV3}}
          @triggerBttp={{this.triggerBttp}}
        />
      {{else if this.bttpHasError}}
        <Calendar::Settings::Bttp::Error
          @bttpInclusionDateText={{this.bttpInclusionDateText}}
          @bttpReport={{@bttpReport}}
          @isLegacyBttp={{this.isLegacyBttp}}
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
          @nickname={{this.socialProfile.displayNickname}}
          @numberOfFollowers={{this.numberOfFollowers}}
          @postPercentageCSS={{this.postPercentageCSS}}
          @profileType={{this.socialProfile.capitalizedProfileType}}
          @requiredFollowers={{this.requiredFollowers}}
          @singleSocialProfile={{this.socialProfile}}
        />
      {{else if this.hasBttpReportData}}
        <Calendar::Settings::Bttp::Report
          @bttpLastCalculatedText={{this.bttpLastCalculatedText}}
          @bttpToggledOn={{@bttpToggledOn}}
          @immediateBttpEnabled={{this.immediateBttpEnabled}}
          @isInstagram={{this.isInstagram}}
          @isLegacyBttp={{this.isLegacyBttp}}
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
          @numOfBttpTimeSlots={{this.numOfBttpTimeSlots}}
          @rolloutBttpV3={{this.rolloutBttpV3}}
          @singleSocialProfile={{this.socialProfile}}
          @toggleBttp={{@toggleBttp}}
          @triggerBttp={{this.triggerBttp}}
        />
      {{else if this.bttpDataExists}}
        <p class="u--text--bold" data-test-id="bttp-fetching-report">
          {{t "bttp.fetching_report"}}
        </p>
      {{else}}
        <Calendar::Settings::Bttp::Generate
          @isOnLegacyPlan={{this.isOnLegacyPlan}}
          @rolloutBttpV3={{this.rolloutBttpV3}}
          @triggerBttp={{this.triggerBttp}}
        />
      {{/if}}
    </div>
  </div>
  */
  {
    "id": "Mhmk+wkU",
    "block": "[[[11,\"hr\"],[24,0,\"u--m__b__0\"],[4,[38,0],[[30,0,[\"handleBttpError\"]]],null],[12],[13],[1,\"\\n\"],[10,0],[14,0,\"u--row at--bttpChecklist__SettingsBttp\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4 u--m__t__md\"],[12],[1,\"\\n    \"],[10,\"h5\"],[14,0,\"u--text--md u--m__t__0\"],[14,\"data-test-id\",\"calendar-settings-bttp-title\"],[12],[1,\"\\n\"],[41,[30,0,[\"isTiktok\"]],[[[1,\"        \"],[1,[28,[35,2],[\"bttp.tiktok.title\"],null]],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,2],[\"bttp.title\"],null]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"u--col__8 u--m__t__md at--bttpRetention__bttpSection\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"canBttp\"]]],null],[[[41,[30,0,[\"isLegacyAccount\"]],[[[1,\"        \"],[8,[39,4],null,null,null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,5],null,[[\"@isOnLegacyPlan\",\"@upgradeButtonText\"],[[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"upgradeButtonText\"]]]],null],[1,\"\\n\"]],[]]]],[]],[[[41,[28,[37,6],[[28,[37,3],[[30,0,[\"rolloutBttpV3\"]]],null],[30,0,[\"notEnoughTikTokFollowers\"]]],null],[[[1,\"      \"],[8,[39,7],null,[[\"@isOnLegacyPlan\",\"@nickname\",\"@numberOfFollowers\",\"@profileType\",\"@requiredFollowers\"],[[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"socialProfile\",\"displayNickname\"]],[30,0,[\"numberOfFollowers\"]],[30,0,[\"socialProfile\",\"capitalizedProfileType\"]],[30,0,[\"requiredFollowers\"]]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,6],[[30,0,[\"isLegacyBttp\"]],[30,0,[\"immediateBttpEnabled\"]]],null],[[[1,\"      \"],[8,[39,8],null,[[\"@isInstagram\",\"@rolloutBttpV3\",\"@triggerBttp\"],[[30,0,[\"isInstagram\"]],[30,0,[\"rolloutBttpV3\"]],[30,0,[\"triggerBttp\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"bttpHasError\"]],[[[1,\"      \"],[8,[39,9],null,[[\"@bttpInclusionDateText\",\"@bttpReport\",\"@isLegacyBttp\",\"@isOnLegacyPlan\",\"@nickname\",\"@numberOfFollowers\",\"@postPercentageCSS\",\"@profileType\",\"@requiredFollowers\",\"@singleSocialProfile\"],[[30,0,[\"bttpInclusionDateText\"]],[30,1],[30,0,[\"isLegacyBttp\"]],[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"socialProfile\",\"displayNickname\"]],[30,0,[\"numberOfFollowers\"]],[30,0,[\"postPercentageCSS\"]],[30,0,[\"socialProfile\",\"capitalizedProfileType\"]],[30,0,[\"requiredFollowers\"]],[30,0,[\"socialProfile\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"hasBttpReportData\"]],[[[1,\"      \"],[8,[39,10],null,[[\"@bttpLastCalculatedText\",\"@bttpToggledOn\",\"@immediateBttpEnabled\",\"@isInstagram\",\"@isLegacyBttp\",\"@isOnLegacyPlan\",\"@numOfBttpTimeSlots\",\"@rolloutBttpV3\",\"@singleSocialProfile\",\"@toggleBttp\",\"@triggerBttp\"],[[30,0,[\"bttpLastCalculatedText\"]],[30,2],[30,0,[\"immediateBttpEnabled\"]],[30,0,[\"isInstagram\"]],[30,0,[\"isLegacyBttp\"]],[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"numOfBttpTimeSlots\"]],[30,0,[\"rolloutBttpV3\"]],[30,0,[\"socialProfile\"]],[30,3],[30,0,[\"triggerBttp\"]]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"bttpDataExists\"]],[[[1,\"      \"],[10,2],[14,0,\"u--text--bold\"],[14,\"data-test-id\",\"bttp-fetching-report\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"bttp.fetching_report\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[8,[39,11],null,[[\"@isOnLegacyPlan\",\"@rolloutBttpV3\",\"@triggerBttp\"],[[30,0,[\"isOnLegacyPlan\"]],[30,0,[\"rolloutBttpV3\"]],[30,0,[\"triggerBttp\"]]]],null],[1,\"\\n    \"]],[]]]],[]]]],[]]]],[]]]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@bttpReport\",\"@bttpToggledOn\",\"@toggleBttp\"],false,[\"did-insert\",\"if\",\"t\",\"not\",\"calendar/settings/bttp/legacy-account\",\"calendar/settings/bttp/enable\",\"and\",\"calendar/settings/bttp/followers\",\"calendar/settings/bttp/upgrade\",\"calendar/settings/bttp/error\",\"calendar/settings/bttp/report\",\"calendar/settings/bttp/generate\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp.hbs",
    "isStrictMode": false
  });
  function getBttpInclusionDates(startDate) {
    if (!_moment.default.isMoment(startDate)) return;
    const sixMonthsAgo = (0, _moment.default)(startDate).subtract(6, 'months');
    const twoWeeksAgo = (0, _moment.default)(startDate).subtract(2, 'weeks');
    return {
      sixMonthsAgo,
      twoWeeksAgo
    };
  }
  let BttpComponent = _exports.default = (_dec = (0, _service.inject)('calendar/bttp'), (_class = class BttpComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "bttp", _descriptor3, this);
      _initializerDefineProperty(this, "intl", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor6, this);
      _initializerDefineProperty(this, "errors", _descriptor7, this);
      _defineProperty(this, "bttpInclusionDates", getBttpInclusionDates((0, _moment.default)()));
      _defineProperty(this, "dateFormat", 'MMMM D, YYYY');
      _defineProperty(this, "triggerBttp", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (refreshBttp) {
          try {
            if (!refreshBttp) {
              return;
            }
            const response = yield this.bttp.generateBttpReport.perform();
            if (response.errors) {
              this.alerts.warning(response.errors);
            } else {
              this.alerts.success(this.intl.t('bttp.success'));
            }
            this.args.closeModal();
            this.segment.track('refreshed-bttp', {
              social_profile: this.socialProfile?.id
            });
          } catch (error) {
            this.alerts.warning(error);
          }
        }
      }), null, "triggerBttp", null));
    }
    get account() {
      return this.auth.currentAccount;
    }
    get bttpDataExists() {
      return this.args.bttpReport?.data;
    }
    get bttpHasError() {
      if (this.bttpDataExists) {
        return this.args.bttpReport.reportErrorText;
      }
      return false;
    }
    get bttpInclusionDateText() {
      if (!this.bttpInclusionDates) {
        return this.errors.log('Missing bttp inclusion dates.', {
          bttpInclusionDates: this.bttpInclusionDates
        });
      }
      const {
        sixMonthsAgo,
        twoWeeksAgo
      } = this.bttpInclusionDates;
      return this.intl.t('bttp.from_date_range', {
        six_months_ago: sixMonthsAgo.format(this.dateFormat),
        two_weeks_ago: twoWeeksAgo.format(this.dateFormat)
      });
    }
    get bttpLastCalculatedText() {
      if (!this.bttpInclusionDates) {
        return this.errors.log('Missing bttp inclusion dates.', {
          bttpInclusionDates: this.bttpInclusionDates
        });
      }
      const {
        sixMonthsAgo,
        twoWeeksAgo
      } = this.bttpInclusionDates;
      const bttpAnalyticsTimestamp = _moment.default.unix(this.args.bttpReport.timestamp);
      return this.intl.t('bttp.last_calculated', {
        date: bttpAnalyticsTimestamp.format(this.dateFormat),
        six_months_ago: sixMonthsAgo.format(this.dateFormat),
        two_weeks_ago: twoWeeksAgo.format(this.dateFormat)
      });
    }
    get canBttp() {
      return this.bttp.canBttp;
    }
    get hasBttpReportData() {
      return this.canBttp && Boolean(this.args.bttpReport?.data?.bttp_data);
    }
    get immediateBttpEnabled() {
      if (this.isOnLegacyPlan) {
        return false;
      }
      if (this.isInstagram || this.rolloutBttpV3) {
        return true;
      }
      return this.validFollowerCount;
    }
    get isOnLegacyPlan() {
      return this.account.isOnLegacyPlan;
    }
    get isLegacyBttp() {
      return this.args.bttpReport?.version === _constants.LEGACY_BTTP_VERSION;
    }
    get numOfBttpTimeSlots() {
      return this.args.bttpReport.timeSlots.length;
    }
    get postPercentageCSS() {
      return this.args.bttpReport.numOfPosts ? `width: ${this.args.bttpReport.numOfPosts / this.args.bttpReport.requiredBttpPostData * 100}%` : 'width: 0%';
    }
    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }
    get upgradeButtonText() {
      if (!this.canBttp) return this.intl.t('shared_phrases.upgrade_plan');
      return '';
    }
    get isTiktok() {
      return Boolean(this.socialProfile?.isTiktok);
    }
    get isInstagram() {
      return Boolean(this.socialProfile?.isInstagram);
    }
    get isLegacyAccount() {
      return this.isTiktok && this.account.isOnLegacyPlan;
    }
    get numberOfFollowers() {
      return this.socialProfile?.followedBy ?? 0;
    }
    get requiredFollowers() {
      return this.bttp.requiredFollowerCount;
    }
    get validFollowerCount() {
      return this.numberOfFollowers >= this.requiredFollowers;
    }
    get notEnoughTikTokFollowers() {
      return this.isTiktok && !this.validFollowerCount;
    }
    get rolloutBttpV3() {
      return this.account.rolloutBttpV3;
    }
    handleBttpError() {
      if (this.bttpHasError) {
        this.triggerBttp.perform(false);
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bttp", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "handleBttpError", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleBttpError"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BttpComponent);
});